module.exports = __webpack_public_path__ + "fonts/Prompt-Light.2aed5273.ttf";